import React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { MuiCheckbox } from '../MaterialUIComponents'
import theme from '../../../assests/theme'
const useStyles = makeStyles({
    root: {
        "&:hover": {
            backgroundColor: "transparent"
        }
    },
    icon: {
        border: "1px solid "+theme.palette.primary.light,
        width: "22px",
        height: "22px",
        backgroundColor: theme.palette.primary.lightest,

        "input:hover ~ &": {
            backgroundColor: theme.palette.primary.lighter 
        },
        "input:disabled ~ &": {
            boxShadow: "none",
            background: theme.palette.primary.lighter
        },
    },
    checkedIcon: {
        border: "1px solid " + theme.palette.primary.light,
        backgroundColor: theme.palette.primary.lightest,

        "&:before": {
            display: "block",
            width: "22px",
            height: "22px",
            backgroundPosition: "center",
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3C%3Fxml version='1.0'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' height='18px' viewBox='0 -46 417.81333 417' width='18px'%3E%3Cg%3E%3Cpath d='m159.988281 318.582031c-3.988281 4.011719-9.429687 6.25-15.082031 6.25s-11.09375-2.238281-15.082031-6.25l-120.449219-120.46875c-12.5-12.5-12.5-32.769531 0-45.246093l15.082031-15.085938c12.503907-12.5 32.75-12.5 45.25 0l75.199219 75.203125 203.199219-203.203125c12.503906-12.5 32.769531-12.5 45.25 0l15.082031 15.085938c12.5 12.5 12.5 32.765624 0 45.246093zm0 0' fill='%234880CE' data-original='%232196F3' class='active-path' data-old_color='%232196f3'/%3E%3C/g%3E%3C/svg%3E%0A\")",
            backgroundRepeat: "no-repeat",
            content: '""',

        },
        "input:hover ~ &": {
            backgroundColor: theme.palette.primary.lighter
        }
    },
    indeterminateIcon: {
        border: "1px solid " + theme.palette.primary.light,
        backgroundColor: theme.palette.primary.main,

        "&:before": {
            display: "block",
            width: "22px",
            height: "22px",
            backgroundPosition: "center",
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3C%3Fxml version='1.0'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' height='22px' viewBox='0 -192 469.33333 469' width='14px'%3E%3Cg%3E%3Cpath d='m437.332031.167969h-405.332031c-17.664062 0-32 14.335937-32 32v21.332031c0 17.664062 14.335938 32 32 32h405.332031c17.664063 0 32-14.335938 32-32v-21.332031c0-17.664063-14.335937-32-32-32zm0 0' data-original='%23000000' class='active-path' data-old_color='%23000000' fill='%23FFFFFF'/%3E%3C/g%3E%3C/svg%3E%0A\")",
            backgroundRepeat: "no-repeat",
            content: '""',

        },
        "input:hover ~ &": {
            backgroundColor: theme.palette.primary.light
        }
    }
});

export default function CheckBox(props) {
    const classes = useStyles();

    return (
        <MuiCheckbox
            className={classes.root}
            indeterminateIcon={<span className={classes.indeterminateIcon} />}
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            inputProps={{ "aria-label": "decorative checkbox" }}
            {...props}
        />
    );
}